import { siteName, headerNav } from '@/mocks/home';

export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-950 text-background-200">
      <div className="section-container py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <a href="#hero" className="flex items-center gap-2 mb-4 cursor-pointer no-underline">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-fill text-background-50 text-base"></i>
              </span>
              <span className="text-lg font-bold text-background-50 font-heading">{siteName}</span>
            </a>
            <p className="text-sm text-background-400 leading-relaxed">
              {siteName}是国内领先的免费高清视频在线播放平台。不缓冲秒播、即点即看零等待，海量电视剧全集电影大全等你来发现。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4 font-heading">快速导航</h4>
            <nav className="flex flex-col gap-2">
              {headerNav.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer no-underline"
                >
                  {item.label}
                </a>
              ))}
            </nav>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4 font-heading">内容分类</h4>
            <nav className="flex flex-col gap-2">
              <a href="#carousel" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer no-underline">热门电视剧</a>
              <a href="#carousel" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer no-underline">高分电影</a>
              <a href="#carousel" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer no-underline">综艺娱乐</a>
              <a href="#carousel" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer no-underline">动漫番剧</a>
              <a href="#carousel" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer no-underline">纪录片</a>
            </nav>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4 font-heading">合作伙伴</h4>
            <p className="text-sm text-background-500 leading-relaxed">
              优质合作伙伴持续加入中，敬请期待。
            </p>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-6 border-t border-background-800">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} {siteName}. 本站所有内容均为免费提供，仅供学习交流。
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-background-500 hover:text-background-200 transition-colors cursor-pointer no-underline">服务条款</a>
            <a href="#hero" className="text-xs text-background-500 hover:text-background-200 transition-colors cursor-pointer no-underline">隐私政策</a>
            <a href="#contact" className="text-xs text-background-500 hover:text-background-200 transition-colors cursor-pointer no-underline">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}